var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiDriven = function SvgAiDriven(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 37 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#204969",
    d: "M32.785.969H4.495A3.856 3.856 0 0 0 .64 4.816v.731h18c.53 0 .963.432.963.962s-.433.962-.963.962h-18v3.049h13.364c.531 0 .964.432.964.962s-.433.962-.964.962H.64v3.048h21.002a.962.962 0 1 1 0 1.924L.64 17.418v3.05h10.986a.962.962 0 1 1 0 1.923H.64v.73a3.856 3.856 0 0 0 3.854 3.848h28.291a3.856 3.856 0 0 0 3.855-3.847V4.817A3.856 3.856 0 0 0 32.785.969"
  })));
};
export default SvgAiDriven;